import { combineReducers } from '@reduxjs/toolkit'
import UserSlice from './userSlice'
import meterSlice from './meterSlice'
import profileSlice from './profileSlice'
import measurementSlice from './measurementSlice'
import consumptionSlice from './consumptionSlice'
import DocumentSlice from './documentSlice'
import StatisticSlice from './statisticSlice'
import notificationLogSlice from './notificationLogSlice'
import historyLogSlice from './historyLogSlice'
import tenantSlice from './tenantSlice'
import paymentSlices from './paymentSlices'
import applicationSlice from './applicationSlice'
import alertsSlice from './alertsSlice'

const rootSlice = combineReducers({
    profile: profileSlice,
    measurement: measurementSlice,
    consumption: consumptionSlice,
    user: UserSlice,
    meter: meterSlice,
    document: DocumentSlice,
    statistic: StatisticSlice,
    notificationLog: notificationLogSlice,
    historyLog: historyLogSlice,
    tenant: tenantSlice,
    payment: paymentSlices,
    application: applicationSlice,
    alert: alertsSlice
})

export default rootSlice
